import type { Feature } from './feature'

/** Selectors for the current slideout widget reference. */
export class Selectors {
  /** TODO:  */
  public readonly widgetRef

  constructor(feature: Feature) {
    this.widgetRef = feature.state.project(state => state.widgetRef)
  }
}
